<template>
	<div class="distributionOrder l">
		<ul class="top"><li @click="fenXiao(0)" :class="{active:Active==0}"><p>未付款 <span> 1</span></p></li><li @click="fenXiao(1)" :class="{active:Active==1}"><p>已付款 <span> 1</span></p></li><li @click="fenXiao(2)" :class="{active:Active==2}"><p>已完成 <span> 2</span></p></li></ul>	
					<div class="thead"><p class="l">宝贝</p><p class="l">单价</p><p class="l">数量</p><p class="l">商品操作</p><p class="l">实付款</p><p class="l">交易状态<i class="el-icon-caret-bottom"></i></p><p class="l">交易操作</p></div>
					<div class="btn"><span>上一页</span><span>下一页</span></div>
					<div class="alike">
					<div class="both"><input class="l" type="checkbox"/><p class="l">2016-12-02</p><p class="l">订单号： 2368480379058336</p><p class="l">店铺：周生生官方旗舰店</p><img src="../../../assets/img/qq.jpg"/><i class="el-icon-delete r"></i></div>
					<div class="zuo l">
						<div class="huowu"><img src="../../../assets/img/samllchahu.png"/><p>梨形壶 国家助理工艺美术师  卢伟萍</p><p>￥49.98</p><p>1</p><router-link to="apply">售后处理</router-link></div>
					</div>
					<div class="right r"><p><span>￥49.98</span><span>（含运费：￥10.00）</span></p><p><span>等待卖家付款</span><span>订单详情</span></p> <p><span>立即付款</span><span>取消订单</span></p></div>
					</div>
	</div>
</template>

<script>
export default {
  data () {
    return {
      Active:'',
    }
  },
  created () {
  },
  methods: {
   fenXiao(index){this.Active=index},
  }
}
</script>


<style lang="less" scoped>
	.l{float: left;}
	.r{float: right;}
	.center {width: 1200px;margin: 0 auto;height: 100%;}
		.distributionOrder{
			width:980px;background: #fff;margin:16px 0;padding-bottom:40px;
			.top{height:37px;border-bottom:1px solid #e7e7e7;margin:14px 17px 23px; li{cursor:pointer; float:left; width:104px;text-align:center;height:35px;font-size:14px;color:#666; p{line-height:16px;border-right:1px solid #eee;margin-top:10px;span{color:#d19e29;}}}li:last-child{p{border-right:0;}}}
			.active{border-bottom:2px solid #d19e29;color:#d19e29 !important;}
			.thead{
				overflow: hidden;height:38px;background:#f5f5f5;border: 1px solid #e7e6e6;margin:0 17px;width:946px;line-height:38px;
				p{font-size:12px;color:#474747;i{color: #999;margin-left:9px;}}
				p:nth-of-type(1){margin:0 205px 0 134px;}p:nth-of-type(3){margin:0 70px 0 50px;}p:nth-of-type(5){margin:0 65px 0 74px;}p:nth-of-type(7){margin-left:51px;}
			}
			.btn{cursor: pointer; text-align: right;margin:14px 17px 15px;span{display: inline-block;width:60px;height:22px;text-align: center;line-height:22px;border:1px solid #dcdcdc;font-size:12px;color:#9c9c9c;border-radius:3px;margin-left:6px;}}
			.alike{overflow:hidden;border:1px solid #e7e6e6;margin: 0 17px 10px;span{cursor:pointer;}
				a{font-size:12px;color:#333;margin-top:20px;display:inline-block;}
				.both{
					height: 42px;line-height:42px;background:#f1f1f1;i{font-size:16px;margin:13px 16px 0 0;color:#999;font-weight:900;}
					input{margin:16px 14px 0 13px;}p{font-size:12px;color:#333;}p:nth-of-type(2){margin:0 67px 0 25px;}img{float:left;margin:9px 0 0 35px;}
				}
				.zuo{overflow:hidden; width:613px;.huowu{height:110px; img{float:left;margin: 15px 10px 0 13px;}p{float:left;font-size:12px;color:#333;margin-top:20px;}
						p:nth-of-type(1){width:147px;margin:18px 117px 0 0;}p:nth-of-type(3){margin:20px 83px 0 44px;}}}
				.right{height:110px;overflow: hidden;
					p{float:left;border-left:1px solid #e7e6e6;height:100%;span{display: block;text-align: center;font-size:12px;color:#333; cursor:pointer;}}
					p:nth-of-type(1){width:120px;span:nth-of-type(1){margin-top:20px;}}p:nth-of-type(2){width:105px;span:nth-of-type(1){margin-top:20px;}}
					p:nth-of-type(3){width:106px;span:nth-of-type(1){margin:17px auto 8px; width:72px;height:28px;line-height:28px;color:#fff;background: #ff6000;border-radius:3px;}}
					.quxiao{background:#cbcaca !important;}.queren{background:#66b6ff !important;}
				}
			}
		}
</style>